import React, { createContext, useState, useCallback, useEffect } from 'react';
import api from '../middlewares/clientSindico';

import translateVector from '../Utils/translator';
import {
  translateTodasSolicitacoes,
  translateGetSolicitacaoSemAgendamento,
  translateGetSolicitacao,
  translateAgendamentosAbertos,
  translateType,
} from '../Utils/translateFunctions';
import { useHistory } from 'react-router-dom';
import { dataToBlob } from '../Utils/dataToBlob';
import { datadogRum } from '@datadog/browser-rum';

import {
  encodeBase64,
  encodeBase64WithoutStringify,
} from '../Pages/Sindico/base64';
import loadSindico from '../Pages/Sindico/loadSindico';
import { stopDatadogRum } from '../DataDog/configs';
import portalEnvironment from '../Utils/baseURL';
import md5 from 'md5';
import { getDateYMD } from '../Utils/formatDate';

const ContextSindico = createContext();

function Sindico({ children }) {
  const [empreendimentoSelecionado, setEmpreedimentoSelecionado] = useState('');
  const [periodoAgente, setPeriodoAgente] = useState([]);

  const [apontamentos, setApontamentos] = useState([]);

  const [listaApontamentosOriginal, setListaApontamentosOriginal] = useState(
    []
  );

  const [folders, setFolders] = useState([]);

  console.log('contexto sindico sendo chamado');

  const [loading, setLoading] = useState(true);

  const [motivoSelecionado, setMotivoSelecionado] = useState('');

  const [apontamentoSelecionado, setApontamentoSelecionado] = useState(
    `Selecione uma categoria de apontamento que melhor descreva o seu reparo.`
  );

  const [resetApontamentoMotivo, setResetApontamentoMotivo] = useState(false);

  const [solicitacoes, setSolicitacoes] = useState([]);

  const [loadingSolicitacoes, setLoadingSolicitacoes] = useState(true);

  const [solicitacoesParaExibir, setSolicitacoesParaExibir] = useState([]);

  const [listaDeImoveis, setListaDeImoveis] = useState([]);

  const [imovelSolicitacao, setImovelSolicitacao] = useState('');

  const [loadingImoveis, setLoadingImoveis] = useState(true);

  const [tiposSolicitacoes, setTiposSolicitacoes] = useState([]);

  const [listaApontamentosSelecionado, setListaApontamentosSelecionado] =
    useState([]);

  const [listaMotivoSelecionado, setlistaMotivoSelecionado] = useState([]);

  // Thiago
  const [removedDocuments, setRemovedDocuments] = useState([]);
  //end Thiago

  const [isSindicoAuthenticated, setIsSindicoAuthenticated] = useState(false);

  const [errorSindicoAuth, setErrorSindicoAuth] = useState(undefined);
  const history = useHistory();

  const tema = { primaryColor: '#1D3054' };

  useEffect(() => {
    if (!empreendimentoSelecionado) {
      setEmpreedimentoSelecionado(listaDeImoveis[0]?.nome);
    }
  }, [listaDeImoveis]);

  useEffect(() => {
    if (isSindicoAuthenticated) {
      const { contactId } = loadSindico();
      if (contactId) {
        datadogRum.setUser({ contactId });
      }
    }
  }, [isSindicoAuthenticated]);

  async function getSolicitacoes(empreendimentoId) {
    const { contactId: sindicoId } = loadSindico();
    console.log('s', sindicoId);
    let result = '';
    try {
      result = await api.get('Sindico/GetSolicitacoesSindico', {
        params: {
          sindicoId,
          empreendimentoId,
        },
      });
      return translateVector(result?.data, translateTodasSolicitacoes);
    } catch (error) {
      return error.request;
    }
  }

  async function getAllSolicitacoes() {
    return api.get('Solicitacao/GetSolicitacoes');
  }

  async function getApontamentos() {
    let result = '';
    try {
      result = await api.get('/Sindico/Apontamentos');

      return result.data;
    } catch (error) {
      return error;
    }
  }

  async function getSolicitacao(idSolicitacao) {
    let resultGetSolicitacao = '';
    try {
      resultGetSolicitacao = await api.get('Sindico/GetSolicitacaoSindico', {
        params: {
          id: idSolicitacao,
        },
      });

      if (resultGetSolicitacao?.data.CompromissoServico == null) {
        return translateVector(
          resultGetSolicitacao?.data,
          translateGetSolicitacaoSemAgendamento
        );
      } else {
        return translateVector(
          resultGetSolicitacao?.data,
          translateGetSolicitacao
        );
      }
    } catch (error) {
      return error.request;
    }
  }

  async function getAnexoSolicitacao(solicitacao) {
    try {
      let response = await api.get('Sindico/GetAnexos', {
        params: {
          caseId: solicitacao?.id,
          assisTec: solicitacao?.subgrupo === 'AT_INCORPORACAO',
        },
      });

      if (response.status >= 200 && response.status < 300) {
        return response?.data;
      }
    } catch (error) {
      return error.request;
    }
  }

  async function getAgendamentosAbertos() {
    let result = '';
    let temp = '';
    try {
      result = await api.get('Solicitacao/AgendamentosAbertos');
      temp = translateVector(result?.data, translateAgendamentosAbertos);

      return temp;
    } catch (error) {
      return false;
    }
  }

  async function getTipoSolicitacoes() {
    let result = '';
    try {
      result = await api.get('Sindico/TiposSolicitacao');
      console.log('resultGetTipoSolicitacoes', result);
      let temp = translateVector(result?.data, translateType);
      setTiposSolicitacoes(temp);

      return temp;
    } catch (error) {
      return error;
    }
  }

  async function cancelarSolicitacao(id, agendamento) {
    try {
      await api.patch(
        'Sindico/CancelarSolicitacao',
        {},
        {
          params: {
            id,
            agendamento,
          },
        }
      );

      return true;
    } catch (error) {
      return false;
    }
  }

  async function getPeriodoAgente(tipoSolicitacao, assetId) {
    try {
      let result = await api.get('Sindico/GetPeriodoAgente', {
        params: {
          tipoSolicitacao: tipoSolicitacao,
          assetId: assetId,
        },
      });
      setPeriodoAgente(result?.data);
      return result?.data;
    } catch (error) {
      return error.response?.data.Falha;
    }
  }

  async function getVerificaAgendamento(tipoSolicitacao, assetId) {
    try {
      let result = await api.get('Sindico/VerificaSolicitacaoAgendamento', {
        params: {
          tipoSolicitacao,
          assetId,
        },
      });

      return result;
    } catch (error) {
      return error.response;
    }
  }

  const criarSolicitacao = async (solicitacao) => {
    const { contactId } = loadSindico();
    let resultPostSolicitacao = '';
    try {
      resultPostSolicitacao = await api.post(
        'Sindico/CriarSolicitacaoSindico',
        {
          ...solicitacao,
          contactId,
        }
      );

      return translateVector(
        resultPostSolicitacao?.data?.result,
        translateGetSolicitacaoSemAgendamento
      );
    } catch (error) {
      return false;
    }
  };

  console.log('removeddocuments no contexto', removedDocuments);

  const saveFiles = async (userDocuments, caseId) => {
    let formData = new FormData();

    formData.append('CaseId', caseId);

    let fileSizeInMb = 0;

    const sendDocuments = async () => {
      try {
        let response;

        if (formData.get('Anexos')) {
          response = await api.post(`Sindico/PostAnexo`, formData);
        }

        if (response) return response;
      } catch (error) {
        return false;
      }
    };

    const getExtension = (file) => {
      console.log('filefilefilefile', file);
      if (file?.url === undefined) {
        if (file?.type !== undefined) {
          return `.${file.type.split('/')[1]}`;
        } else if (file?.includes('application/pdf')) {
          return '.pdf';
        } else if (file?.includes('video/mp4')) {
          return '.mp4';
        } else if (file?.includes('video/webm')) {
          return '.webm';
        } else if (file?.includes('video/avi')) {
          return '.avi';
        } else if (file?.includes('video/mkv')) {
          return '.mkv';
        }
      }
    };

    const verifyExtension = async (file, workTypeId) => {
      if (file.url === undefined) {
        // verifica se não é uma imagem que veio pela api
        let fileName =
          workTypeId === null || workTypeId === undefined
            ? `imagem${getExtension(file)}`
            : `_ReparoID_${workTypeId}${getExtension(file)}`;

        if (typeof file === 'string') {
          formData.append('Anexos', dataToBlob(file), fileName);
        } else {
          formData.append('Anexos', file, fileName);
        }
      }
    };

    const getSumOfSizes = async (file, workTypeId) => {
      let currentFileSize = 0;

      if (typeof file === 'string') {
        currentFileSize += dataToBlob(file).size / 1024 / 1024;
      } else {
        currentFileSize += file.size / 1024 / 1024;
      }

      if (currentFileSize + fileSizeInMb < 30) {
        fileSizeInMb += currentFileSize;

        await verifyExtension(file, workTypeId);
      } else {
        await sendDocuments();

        formData.delete('Anexos');

        fileSizeInMb += currentFileSize;

        await verifyExtension(file, workTypeId);
      }
    };

    for (let i = 0; i < userDocuments?.length; i++) {
      if (
        userDocuments[i]?.documents === undefined &&
        userDocuments[i]?.apontamento
      ) {
        continue;
      }

      if (userDocuments[i]?.documents === undefined) {
        console.log('no if user documents', userDocuments[i]);
        await getSumOfSizes(userDocuments[i], null);
      } else {
        for (let j = 0; j < userDocuments[i]?.documents?.length; j++) {
          await getSumOfSizes(
            userDocuments[i]?.documents[j],
            userDocuments[i]?.workTypeId
          );
        }
      }
    }

    console.log('formData', formData);

    await sendDocuments();
  };

  const removeFiles = async (documents, caseId) => {
    documents?.forEach(async (document) => {
      try {
        let response = await api.delete('Sindico/ExcluirAnexo', {
          params: {
            caseId: caseId,
            chaveS3: document.idAws,
          },
        });

        if (response) return response;
      } catch (error) {
        return false;
      }
    });
  };

  const aceiteTermoAgendamento = async (
    caseNumber,
    caseIdSalesForce,
    subgrupo
  ) => {
    const { contactId } = loadSindico();
    try {
      await api.post('Sindico/AceitarTermo', {
        caseNumber,
        caseIdSalesForce,
        subgrupo,
        contactId,
      });
    } catch (error) {
      return false;
    }
  };

  const editAssistenciaTecnica = async (apontamentosEdicao) => {
    try {
      await api.put('Sindico/AtualizaApontamento', {
        ...apontamentosEdicao,
      });
    } catch (error) {
      return false;
    }
  };

  const criarAgendamento = async (agendamento) => {
    let resultPostAgendamento = '';
    try {
      resultPostAgendamento = await api.post(
        'Sindico/CriarAgendamentoSindico',
        {
          ...agendamento,
        },
        {}
      );

      return translateVector(
        resultPostAgendamento?.data,
        translateGetSolicitacao
      );
    } catch (error) {
      return error.request;
    }
  };

  async function getSolicitacaoUnica(id) {
    history.push(`/sindico/acompanhar-solicitacao/${id}`);
  }

  async function loadApontamentos(apontamentosAntigos) {
    setLoading(true);
    let arrayItensApontamentos = [];
    let resultadoGetApontamentos;

    try {
      // get da lista de todos apontamentos
      resultadoGetApontamentos = await getApontamentos();
      resultadoGetApontamentos.forEach((apontamento) => {
        arrayItensApontamentos.push({
          nome: apontamento.Descricao,
          id: apontamento.Descricao,
          idSalesForce: apontamento.IdSalesForce,
        });
      });
      setListaApontamentosOriginal(resultadoGetApontamentos);

      if (apontamentosAntigos)
        removeApontamentosAntigos(arrayItensApontamentos, apontamentosAntigos);
      else {
        setApontamentos(arrayItensApontamentos);
      }
      setLoading(false);
    } catch (error) {
      return error;
    }

    // guarda a lista de apontamentos original

    // seta a lista de apontamentos para o dropdown
    // setApontamentos(arrayItensApontamentos.sort(dynamicSort("nome")));
  }

  const removeApontamentosAntigos = (
    apontamentosNovos,
    apontamentosAntigos
  ) => {
    let filtered;

    apontamentosAntigos.forEach((antigo) => {
      if (filtered) {
        filtered = filtered.filter((filt) => filt.nome != antigo.apontamento);
      } else
        filtered = apontamentosNovos.filter(
          (novo) => novo.nome != antigo.apontamento
        );
    });

    setApontamentos(filtered.sort(dynamicSort('nome')));
  };

  function loadMotivos() {
    let arrayTemporarioMotivos = [];
    let arrayMotivos;
    try {
      arrayMotivos = listaApontamentosOriginal.filter(filtraMotivos);
      arrayMotivos[0].ApontamentoMotivos.forEach((motivo) => {
        arrayTemporarioMotivos.push({
          nome: motivo.Descricao,
          id: motivo.Descricao,
          idSalesForce: motivo.IdSalesForce,
          prazoDias: motivo.PrazoDias,
        });
      });
    } catch (error) {
      return error;
    }

    setlistaMotivoSelecionado(arrayTemporarioMotivos.sort(dynamicSort('nome')));

    if (arrayTemporarioMotivos.length === 1)
      setMotivoSelecionado(arrayTemporarioMotivos[0].nome);
  }

  function filtraMotivos(apontamento) {
    return apontamento.Descricao == apontamentoSelecionado;
  }

  function dynamicSort(property) {
    let sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      let result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  function removeMotivo(motivo) {
    let resultRemoveMotivo = listaApontamentosSelecionado.filter(
      (motiv) => motiv.idSalesForce !== motivo.idSalesForce
    );

    setListaApontamentosSelecionado(resultRemoveMotivo);

    for (let index = 0; index < listaApontamentosOriginal.length; index++) {
      if (
        listaApontamentosOriginal[index].Descricao ==
        motivo.apontamentoSelecionado
      ) {
        listaApontamentosOriginal[index].ApontamentoMotivos.push({
          Descricao: motivo.motivoSelecionado,
          IdSalesForce: motivo.idSalesForce,
          PrazoDias: motivo.prazoDias,
        });

        listaApontamentosOriginal[index].ApontamentoMotivos.sort(
          dynamicSort('descricao')
        );
      }
    }
    setlistaMotivoSelecionado('');
    setResetApontamentoMotivo(true);
  }

  const minhasSolicitacoes = useCallback(async () => {
    let resultGet = {};
    let finalSolicitacoes = {};
    try {
      resultGet = await getAllSolicitacoes();
      finalSolicitacoes = translateVector(
        resultGet?.data,
        translateTodasSolicitacoes
      );

      setSolicitacoes(finalSolicitacoes);

      setSolicitacoesParaExibir(finalSolicitacoes);
    } catch {
      setSolicitacoes([]);

      setSolicitacoesParaExibir([]);
    } finally {
      setLoadingSolicitacoes(false);
    }
  });

  async function loadImoveisDisponiveis() {
    let imoveisDisponiveis = [];
    try {
      let resultImoveisDisponiveis = loadSindico();
      resultImoveisDisponiveis?.empreendimentos?.forEach((imovel) => {
        imoveisDisponiveis.push({
          assetId: imovel.assetId,
          id: imovel.empreendimentoId,
          nome: imovel.nomeEmpreendimento,
          bloqueio: imovel.bloqueio,
          serviceTerritoryId: imovel.territorioServico,
          codigoObra: imovel.codigoObra,
          codigosUAU: imovel.codigosUAU,
          dataEntrega: imovel.dataEntrega,
          temDocumentos: imovel.temDocumentos,
        });
      });

      setListaDeImoveis(imoveisDisponiveis);

      if (imoveisDisponiveis?.length === 1)
        setImovelSolicitacao(imoveisDisponiveis[0].nome);

      setLoadingImoveis(false);
    } catch (error) {
      return error.request;
    }
  }

  const getUrlDocuments = () => {
    const sindicoInfos = loadSindico();
    const email = sindicoInfos?.email;
    const urlDocumentsSindico = sindicoInfos?.urlDocumentsSindico;

    if (email && urlDocumentsSindico) {
      const emailBase64 = encodeBase64WithoutStringify(email);
      const date = getDateYMD();
      const diaryKey = md5(date + emailBase64);

      const urlDocuments = `${urlDocumentsSindico}/${emailBase64}/${diaryKey}`;

      return urlDocuments;
    }
  };

  const handleSindicoAuthentication = async ({ cpfCnpj, email }) => {
    if (errorSindicoAuth) {
      setErrorSindicoAuth(undefined);
    }
    try {
      const { data } = await api.get('Sindico/GetSindico', {
        params: {
          cpfCnpj,
          email,
        },
      });

      const COD_OBRA_REDIRECT_GUIARE = '315VB';
      console.log('data', data);
      // console.log('finalSindicoData', finalSindicoData);
      sessionStorage.setItem(
        'sindico',
        encodeBase64({
          ...data,
          cpfCnpj,
          email,
          urlDocumentsSindico: `${portalEnvironment.BaseUrlDocumentsSindico}`,
          redirectToGuiare:
            data?.empreendimentos[0]?.codigoObra === COD_OBRA_REDIRECT_GUIARE,
        })
      );

      history.push('/sindico/inicio');
      setIsSindicoAuthenticated(true);
    } catch (error) {
      setErrorSindicoAuth(error.request);
      console.log('error.request', error.request);
      return error.request;
    }
  };

  const logoutSindico = () => {
    stopDatadogRum();
    sessionStorage.removeItem('sindico');
    history.push('/sindico');
  };

  const getFolders = useCallback(async () => {
    try {
      if (folders?.length > 0) return;

      const { data } = await api.get('Sindico/GetPastas');

      if (data) {
        setFolders(data);

        return true;
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        return false;
      }

      return undefined;
    }
  }, []);

  const listDocuments = useCallback(
    async ({
      IdEmpreendimento,
      IdPasta,
      pagina = 1,
      quantidadePorPagina = 3,
    }) => {
      try {
        const { data } = await api.get(`Sindico/GetDocumentos`, {
          params: {
            IdEmpreendimento,
            IdPasta,
            pagina,
            quantidadePorPagina,
          },
        });

        const documents = {
          filesFounded: data['listaEntidades'],
          pagina: data['pagina'],
          qtdDePaginas: data['qtdDePaginas'],
          itensQtdTotal: data['itensQtdTotal'],
        };

        return documents;
      } catch (error) {
        console.log(error);
      }
    },
    []
  );

  const verifyIfUrlIsValid = useCallback(async (url, idAws) => {
    try {
      const urlParams = new URLSearchParams(url);

      const expiresUrl = new Date(urlParams.get('Expires') * 1000);

      const currentDate = new Date();

      if (currentDate >= expiresUrl) {
        const { data: newUrl } = await api.get('Sindico/GetDocumentoByIdAws', {
          params: { idAws },
        });
        return newUrl;
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  const handleClickDocuments = () => {
    const { redirectToGuiare } = loadSindico();

    if (redirectToGuiare) {
      const urlDocuments = getUrlDocuments();
      window.open(urlDocuments, '_blank', 'noreferrer');
      return;
    }

    history.push('/sindico/documentos/');
  };
  return (
    <ContextSindico.Provider
      value={{
        empreendimentoSelecionado,
        setEmpreedimentoSelecionado,
        getSolicitacoes,
        getSolicitacao,
        getAnexoSolicitacao,
        getTipoSolicitacoes,
        getApontamentos,
        cancelarSolicitacao,
        criarSolicitacao,
        getPeriodoAgente,
        getVerificaAgendamento,
        criarAgendamento,
        getAgendamentosAbertos,
        periodoAgente,
        getSolicitacaoUnica,
        editAssistenciaTecnica,
        loadApontamentos,
        apontamentos,
        setApontamentos,
        listaApontamentosOriginal,
        dynamicSort,
        loadMotivos,
        listaMotivoSelecionado,
        setlistaMotivoSelecionado,
        motivoSelecionado,
        setMotivoSelecionado,
        apontamentoSelecionado,
        setApontamentoSelecionado,
        loading,
        resetApontamentoMotivo,
        setResetApontamentoMotivo,
        listaApontamentosSelecionado,
        setListaApontamentosSelecionado,
        removeMotivo,
        setListaApontamentosOriginal,
        minhasSolicitacoes,
        solicitacoes,
        loadingSolicitacoes,
        solicitacoesParaExibir,
        setSolicitacoesParaExibir,
        loadImoveisDisponiveis,
        listaDeImoveis,
        loadingImoveis,
        imovelSolicitacao,
        setImovelSolicitacao,
        aceiteTermoAgendamento,
        setLoadingSolicitacoes,
        saveFiles,
        removeFiles,
        removedDocuments,
        setRemovedDocuments,
        tiposSolicitacoes,
        isSindicoAuthenticated,
        handleSindicoAuthentication,
        setIsSindicoAuthenticated,
        tema,
        errorSindicoAuth,
        logoutSindico,
        folders,
        getFolders,
        listDocuments,
        verifyIfUrlIsValid,
        getUrlDocuments,
        handleClickDocuments,
      }}
    >
      {children}
    </ContextSindico.Provider>
  );
}

export { Sindico, ContextSindico };
